var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFoldericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_977_14487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.347 21.0765H6.43769C6.01689 21.0765 5.67578 20.7354 5.67578 20.3146V4.98375C5.67573 3.86227 6.58487 2.95312 7.70636 2.95312H21.9709C23.0924 2.95312 24.0015 3.86227 24.0015 4.98375V19.422C24.0015 20.3359 23.2609 21.0765 22.347 21.0765Z",
    fill: "#7E57C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.43773 21.0766H22.347C23.2609 21.0766 24.0016 20.3357 24.0016 19.422V6.3272L22.4193 4.74503C22.161 4.4566 21.7858 4.27496 21.3681 4.27496H5.80328C5.71879 4.50172 5.67561 4.74178 5.67578 4.98376V20.3147C5.67578 20.7354 6.01694 21.0766 6.43773 21.0766V21.0766Z",
    fill: "#7E57C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53245 4.43572C6.81258 5.315 7.62942 5.91191 8.5523 5.91191H14.1784C14.104 5.91191 14.0304 5.90769 13.9575 5.9L11.6735 3.61742C11.2822 3.20689 10.7327 2.95953 10.1389 2.95953H7.74422C7.09692 2.95953 6.51759 3.25011 6.12891 3.70752C6.31032 3.92113 6.44749 4.16866 6.53245 4.43572Z",
    fill: "url(#paint0_linear_977_14487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3649 21.0765H2.82509C2.0458 21.0765 1.41406 20.4448 1.41406 19.6655V5.68578C1.41406 4.90648 2.0458 4.27475 2.82509 4.27475H21.3649C22.1442 4.27475 22.7759 4.90648 22.7759 5.68578V19.6655C22.7759 20.4447 22.1442 21.0765 21.3649 21.0765V21.0765Z",
    fill: "#B99DE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8123 6.57699C20.4259 6.16777 19.8786 5.91193 19.2712 5.91193H1.41406V19.6655C1.41406 20.4448 2.0458 21.0766 2.82509 21.0766H21.3649C22.1442 21.0766 22.7759 20.4448 22.7759 19.6655V8.54063L20.8123 6.57699Z",
    fill: "#B99DE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53572 4.43572C6.81584 5.315 7.63269 5.91191 8.55556 5.91191H14.1816C14.1073 5.91191 14.0337 5.90769 13.9608 5.9L12.3346 4.27475H6.47656C6.49812 4.32748 6.51828 4.38078 6.53572 4.43572Z",
    fill: "url(#paint1_linear_977_14487)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3572 6.44638V5.91191H14.179C13.2563 5.91191 12.4395 5.315 12.1593 4.43572C11.8792 3.55639 11.0624 2.95953 10.1395 2.95953H7.74483C6.57422 2.95953 5.625 3.90856 5.625 5.07931V6.44638H14.3572Z",
    fill: "#B99DE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53414 4.43572C6.25397 3.55639 5.43712 2.95953 4.51448 2.95953H2.11983C0.949031 2.95953 0 3.90856 0 5.07931V18.9831C0 20.1392 0.937312 21.0765 2.09344 21.0765H21.9716C21.6519 21.0765 21.3928 20.8174 21.3928 20.4977V8.03174C21.3928 6.86113 20.4437 5.91191 19.2729 5.91191H8.55394C7.63111 5.91191 6.81426 5.315 6.53409 4.43572H6.53414Z",
    fill: "#7E57C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_977_14487",
    x1: 13.2325,
    y1: 8.21821,
    x2: 7.13189,
    y2: 2.11761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9517",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#EE8421",
    stopOpacity: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    stopColor: "#E07728",
    stopOpacity: 0.678
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB722B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_977_14487",
    x1: 13.1747,
    y1: 8.15712,
    x2: 7.62195,
    y2: 2.60436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#8190A4",
    stopOpacity: 0.671
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_977_14487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoldericon);
export default __webpack_public_path__ + "static/media/foldericon.3910c0673559ad584728e8c282cdb8eb.svg";
export { ForwardRef as ReactComponent };